import { countBy } from 'lodash';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const getBlockTypePlugins = (blocks) => blocks.filter((block) => block.type !== "unstyled" && block.type !== "atomic");
const countByType = (obj) => countBy(obj, (x) => x.type);
function getContentSummary(content) {
  const { blocks, entityMap } = content;
  const blockPlugins = getBlockTypePlugins(blocks);
  const entries = Object.values(entityMap);
  const pluginsDetails = entries.filter((entry) => entry.type !== "text").map((entry) => ({ type: entry.type, data: entry.data }));
  return {
    pluginsCount: __spreadValues(__spreadValues({}, countByType(blockPlugins)), countByType(entries)),
    pluginsDetails
  };
}

export { countByType, getBlockTypePlugins, getContentSummary };
